import { api } from "../apiCore";
import { IMemberUL } from "../../slice/applicationDataToBankSlice/applicationDataToBankSlice";
import { changeMemberUlErrorStatusMessages } from "./config/errorHandling";

export const juridicalApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // добавить юр лицо
    addMemberUl: builder.mutation<
      IMemberUL,
      {
        inn: number;
        applicationBankId: number;
      }
    >({
      query: (value) => ({
        url: `/auth/applications/system-bank/create-data-to-bank/${value.applicationBankId}/member-ul`,
        method: "POST",
        body: { inn: value.inn },
      }),
      transformResponse: (response: { data: IMemberUL }) => response.data,
      invalidatesTags: (result, error, arg) => [
        { type: "ApplicationBank", applicationBankId: arg.applicationBankId },
      ],
    }),

    // удалить юр лицо
    deleteMemberUl: builder.mutation<
      IMemberUL,
      { applicationBankId: number | string; ul_id: number | string }
    >({
      query: (value) => ({
        url: `/auth/applications/system-bank/create-data-to-bank/${value.applicationBankId}/member-ul/${value.ul_id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "ApplicationBank", applicationBankId: arg.applicationBankId },
      ],
    }),

    // изменить юр лицо
    changeMemberUl: builder.mutation<
      IMemberUL,
      {
        applicationBankId: number;
        ul_id: number | string;
        percent: number;
      }
    >({
      query: (value) => ({
        url: `/auth/applications/system-bank/create-data-to-bank/${value.applicationBankId}/member-ul/${value.ul_id}`,
        method: "PUT",
        body: { percent: value.percent },
      }),

      /* Обработка ошибок */
      transformErrorResponse(response) {
        const errorStatusMessages = changeMemberUlErrorStatusMessages;
        const { status: errorStatus } = response;

        if (errorStatus === 403) {
          return response;
        }

        for (const [statusCode, statusMessage] of Object.entries(
          errorStatusMessages
        )) {
          if (Number(statusCode) === errorStatus) {
            response.data.message = statusMessage;
            return response;
          }
        }
      },
    }),
  }),
});

export const {
  useAddMemberUlMutation,
  useDeleteMemberUlMutation,
  useChangeMemberUlMutation,
} = juridicalApi;
